import React, { ReactNode, MouseEvent } from "react";
import { Divider } from "@mui/material";
import { styled } from "@iventis/styles";
import { InteractiveElement } from "@iventis/styles/src/components";
import { Theme } from "@emotion/react";
import { DisabledOverlay, SimpleTooltip } from "@iventis/components";

export interface RunSheetMenuOption {
    disabled: boolean;
    visible: boolean;
    onClicked: (event: MouseEvent<HTMLButtonElement>) => void;
    component: ReactNode;
    altText: string;
    key: string;
    dataCy?: string;
}
export const RunSheetMenu: React.FC<{ options: RunSheetMenuOption[] }> = ({ options }) => (
    <div>
        <Divider />
        <MenuContents>
            {options.map((option) => (
                <SimpleTooltip text={option.altText} placement="top">
                    <span style={{ position: "relative" }}>
                        {option.disabled && <DisabledOverlay />}
                        <MenuButton
                            key={option.key}
                            onClick={(event) => {
                                if (option.onClicked != null && !option.disabled) option.onClicked(event);
                            }}
                            disabled={option.disabled}
                            data-cy={option.dataCy}
                        >
                            <span className="hidden">{option.altText}</span>
                            {option.component}
                            {option.disabled && <DisabledOverlay />}
                        </MenuButton>
                    </span>
                </SimpleTooltip>
            ))}
        </MenuContents>
    </div>
);

const MenuButton = styled(InteractiveElement)<{ disabled: boolean }>`
    width: ${({ theme }: { theme: Theme }) => theme.sizes.iconButtonWidth};
    height: ${({ theme }: { theme: Theme }) => theme.sizes.iconButtonWidth};
    position: relative;
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    &:hover {
        background-color: ${({ theme, disabled }: { theme: Theme; disabled: boolean }) => (disabled ? theme.typographyColors.blank : theme.otherColors.hover)};
    }
`;

const MenuContents = styled.div`
    display: flex;
    flex-direction: row-reverse;
`;
